import { FC } from 'react';

import { Tabs, Tab } from '@mui/material';

import { VipSystemTabsEnum } from '../constants';

import { VipSettingsPageTabsProps } from './types';

import styles from './VipSettingsPageTabs.module.css';

const { tabsContainer } = styles;

export const VipSettingsPageTabs: FC<VipSettingsPageTabsProps> = ({ currentTab, setTab, tabFilter }) => {
  const tabs = Object.values(VipSystemTabsEnum);

  return (
    <Tabs className={tabsContainer} textColor="inherit" value={currentTab} variant="scrollable" scrollButtons="auto">
      {tabs.map((tab: VipSystemTabsEnum) => {
        const onClick = () => setTab(tab);

        return tabFilter(tab) && <Tab onClick={onClick} label={tab} value={tab} key={tab} />;
      })}
    </Tabs>
  );
};
